<template>
  <div class="submit-container">
    <transition name="fade-in">
      <div
        class="cart-container flex-between shadow"
        v-if="cartProductNum > 0"
        @click="showCartListHandle"
      >
        <div
          class="cart-icon flex-center"
          @click.stop="loadCartPayTypeListData"
        >
          <p class="cart-text">{{ letter.submit }}</p>
          <em class="cart-dot flex-center" v-show="cartTotalQuantity > 0">
            {{ cartTotalQuantity }}
          </em>
        </div>
        <div class="cart-info">
          <p class="cart-sum">
            {{ letter.v3Total }}
          </p>
          <div class="cart-info-cart j-click-open-cart">
            {{ realPrice }} {{ currency }}
            <Icon
              class="cart-info-ico"
              :class="{ active: showCartList }"
              name="down"
            ></Icon>
          </div>
        </div>
      </div>
    </transition>
    <transition name="slide-up">
      <cart-list
        v-if="showCartList"
        v-on:closeSelecter="setShowCartList(false)"
      ></cart-list>
    </transition>
  </div>
</template>

<script>
import CartList from '@components/officialTopup/cart/CartList.vue';
import {
  UPDATE_HAS_SELECT_PRODUCT,
  SET_SHOW_CHANNEL_STATUS,
  SET_HAS_LOAD_PAYTYPE
} from '@store/officialTopup';
import { UPDATE_SHOW_CARTLIST_STATUS } from '@store/officialTopup/cart';

import { mapState, mapGetters } from 'vuex';
import { times, b64EncodeUnicode } from '@utiles/officialStore';

import coupon from '@mixins/officialTopup/coupon';
import pay from '@mixins/officialTopup/pay';
import zipcode from '@mixins/officialTopup/zipcode';
import cartAddAndDetail from '@mixins/officialTopup/cartAddAndDetail';

export default {
  name: 'cartSubmitFooter',
  mixins: [coupon, pay, zipcode, cartAddAndDetail],
  props: ['submitLoading'],
  data() {
    return {
      currency: '',
      lookDetailItem: {}
    };
  },
  computed: {
    ...mapState({
      letter: state => state.letter,
      hasLoadPaytype: state => state.hasLoadPaytype,
      coin_name: state => state.coin_name,
      paytype: state => state.paytype,
      lang: state => state.lang,
      showCartList: state => state.cart.showCartList,
      cartList: state => state.cart.cartList,
      isUidLogin: state => state.login.isUidLogin
    }),
    ...mapGetters([
      'cartTotalPrice',
      'cartTotalExtraCoin',
      'cartTotalQuantity',
      'cartDiscountTransMount',
      'getPointPayChannelName',
      'extraCoinName',
      'isCart',
      'cartProductNum'
    ]),
    reductionName() {
      return (
        '-' +
        this.activeCouponInfo.REDUCTION_MONEY +
        this?.paytype?.show_currency
      );
    },
    discountName() {
      return times(this.activeCouponInfo.DISCOUNT, 100) + '%OFF';
    },
    submitOrderBtnText() {
      if (
        this?.paytype &&
        this?.paytype?.f_pay_type === this.getPointPayChannelName &&
        this.isUidLogin
      ) {
        return this.letter.uidLoginName;
      } else {
        return this.letter.submitOrder;
      }
    }
  },
  watch: {
    cartList: {
      deep: true,
      handler(newVal) {
        if (newVal.length === 0) {
          this.setShowCartList(false);
          this.$store.commit(UPDATE_HAS_SELECT_PRODUCT, false);
          this.$store.commit(SET_SHOW_CHANNEL_STATUS, false);
          this.$store.commit(SET_HAS_LOAD_PAYTYPE, false);
        }
      }
    },
    paytype: {
      deep: true,
      immediate: true,
      handler(newVal) {
        if (newVal?.show_currency) {
          this.currency = newVal?.show_currency;
        }
      }
    }
  },
  methods: {
    setShowCartList(status) {
      this.$store.commit(UPDATE_SHOW_CARTLIST_STATUS, status);
    },
    lookCartList() {
      this.setShowCartList(true);
      this.sendCheckCartData();
    },
    showCartListHandle() {
      if (this.showCartList) {
        this.setShowCartList(false);
      } else {
        this.setShowCartList(true);
        this.sendCheckCartData();
      }
    }
  },
  components: {
    CartList
  }
};
</script>

<style lang="scss" scoped>
@import '@assets/scss/officialTopup/_dimen.scss';

.submit-container {
  display: none;
  position: fixed;
  left: 0;
  bottom: 26px;
  z-index: 21;
  box-sizing: border-box;
  width: 600px;
}

.cart-container {
  z-index: 1;
  width: 100%;
  height: 80px;
  padding-right: 20px;
  background-color: #ffffff;
  border-radius: 20px;
  cursor: pointer;
  .cart-icon {
    flex-shrink: 0;
    position: relative;
    left: 0;
    top: 0;
    width: 138px;
    height: 80px;
    background-color: $themeColor;
    border-radius: 20px;
    .cart-text {
      font-size: 26px;
      font-weight: bold;
      color: #ffffff;
    }
    .cart-dot {
      position: absolute;
      top: -10px;
      right: -10px;
      min-width: 12px;
      min-height: 28px;
      padding: 0 6px;
      box-sizing: border-box;
      background-color: $themeColor;
      border: solid 3px #ffffff;
      font-size: 18px;
      color: #fff;
      border-radius: 14px;
    }
  }

  .cart-info {
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-end;
    height: 100%;
    padding: 0 20px;
    box-sizing: border-box;
    .cart-sum {
      font-size: 18px;
    }
    .cart-info-cart {
      margin-top: 10px;
      font-size: 26px;
      font-weight: bold;
      color: #333333;
      cursor: pointer;
      position: relative;

      .cart-info-ico {
        position: absolute;
        top: 0;
        right: -24px;
        width: 20px;
        height: 20px;
        color: #333333;

        &.active {
          transform: rotate(180deg);
        }
      }
    }
  }
}
.cart-double-tip {
  position: absolute;
  display: flex;
  align-items: center;
  left: 0;
  top: -38px;
  width: 100%;
  height: 38px;
  border-top: 1px solid var(--submit-cart-double-tip-border);
  border-bottom: 1px solid var(--submit-cart-double-tip-border);
  font-size: 20px;
  background: var(--submit-cart-double-tip-bg);
  color: var(--submit-cart-double-tip);
  box-sizing: border-box;
  font-weight: bold;
  &-ico {
    position: relative;
    margin: 0 5px 0 36px;
    @psetbg ('cart-double-tip-ico.png');
  }
}
.cart-guide-tip {
  position: absolute;
  display: flex;
  align-items: center;
  left: 0;
  top: -50px;
  width: 100%;
  height: 50px;
  font-size: 22px;
  background-color: #e5d9cc;
  border: solid 2px #bca892;
  color: #906d1d;
  box-sizing: border-box;
  font-weight: bold;
  cursor: pointer;
  &.moreTop {
    top: -88px;
  }
  &-ico {
    position: relative;
    margin: 0 5px 0 16px;
    @psetbg ('cart-guide-ico.png');
  }
  &-btn {
    position: absolute;
    right: 27px;
    top: 50%;
    transform: translateY(-50%);
    @psetbg ('cart-guide-btn.png');
  }
}
.detail-container {
  display: block;
  float: left;
  position: relative;
  box-sizing: border-box;
  padding: 22px 0;
  width: 100%;
  height: 180px;
  &.coupon {
    height: 236px;
  }
}
.order-detail {
  &-head {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 24px;
    &-title {
      color: var(--submit-title);
    }
    &-cart {
      color: var(--submit-cart);
    }
  }
  &-content {
    display: flex;
    justify-content: space-between;
    margin-top: 8px;
    .order-detail-price {
      font-size: 30px;
      color: var(--submit-discount);
      .discount-price {
        display: flex;
        font-weight: bold;
        align-items: end;
        .price-wrap {
          display: flex;
          flex-direction: column;
        }
        .discount-total {
          font-size: 41px;
        }
        .price-total {
          text-decoration: line-through;
          text-decoration-color: var(--submit-price-hua);
          font-size: 24px;
          color: var(--submit-price);
        }
      }
      .price {
        font-weight: bold;
        .price-total {
          font-size: 41px;
        }
      }
      .paytype-tip {
        margin-top: 10px;
        font-size: 20px;
        color: var(--submit-tip);
      }
      .extra {
        display: inline-block;
        margin-top: 10px;
        padding: 5px 10px;
        border: 1px solid var(--submit-extra-border);
        text-align: center;
        font-size: 20px;
        color: var(--submit-extra);
      }
    }
    .order-detail-right {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      &.flexEnd {
        justify-content: flex-end;
      }
      .order-coupon {
        &-choose {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          margin-bottom: 15px;
          padding: 5px 10px;
          border: 1px solid var(--submit-coupon-choose-border);
          font-size: 24px;
          color: var(--submit-coupon-choose);
          &-text {
            line-height: 30px;
          }
        }
        &-tip {
          margin-bottom: 15px;
          font-size: 20px;
          color: var(--submit-tip);
        }
        .highligh {
          color: var(--submit-coupon-unchoose);
        }
      }
      .submit-btn {
        display: flex;
        justify-content: center;
        align-items: center;
        background-size: cover;
        cursor: pointer;
        font-size: 24px;
        color: var(--submit-btn);
      }
    }
  }
}
@media screen and (orientation: landscape) {
  .submit-container {
    display: flex;
    left: 50%;
    transform: translateX(-50%);
  }
  .order-detail-content .order-detail-right .submit-btn {
    display: flex;
  }
}
</style>
